import { Injectable } from '@angular/core';
import { HttpService } from '@sdbn/appclient';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { VisitIdentity, VisitOverviewResponse } from './personal-visit-list.model';


@Injectable({
  providedIn: 'root'
})
export class PersonalVisitListService {

  constructor(private tmcHttpService: HttpService) { }

  public getPersonalVisits(visitIdentity: VisitIdentity): Observable<VisitOverviewResponse> {
    const url = `${environment.visitOverviewEndpoint}/personalvisits`;
    return this.tmcHttpService.postWithContext<VisitOverviewResponse>(url, visitIdentity);
  }
}
